import NbrOfAccountsText from '@/components/custom/NbrOfAccountsText.tsx';
import { getTimeSince, isEmptyString } from '@/lib/utils.ts';
import BadgeUserCertified from '../BadgeUserCertified';
import { IHasCertification } from '.';

type TProps = IHasCertification & {
	readonly?: boolean;
};

const UserCertificationItemInfos = ({ certification, readonly = false }: TProps) => (
	<div className={'flex flex-col space-y-2'}>
		{
			!isEmptyString(certification?.reviewerData?.username) &&
			<p className={'flex items-center space-x-1 justify-center text-sm text-muted-foreground'}>
				<BadgeUserCertified 
					forceDisplay 
					size={16} />
				<span>
					Effectuée par: {certification?.reviewerData?.username}
				</span>
			</p>
		}
		<NbrOfAccountsText
			align='center'
			userId={certification?.userData?._id}
			deviceAccountsCount={certification?.userData?.deviceAccountsCount} />
		<span className={'text-center text-sm text-muted-foreground'}>
			{
				!readonly
					? getTimeSince(certification.createdAt, 'Certification demandée')
					: getTimeSince(certification.updatedAt, 'Certification effectuée')
			}
		</span>
		{
			certification
				.userData
				?.incognito &&
			<span className={'text-center text-sm text-gray-500'}>
				🥸 Incognito: OUI
			</span>
		}
	</div>
);

export default UserCertificationItemInfos;

